import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import TeamDetail from './components/TeamDetail'; // 未使用，已注释
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import Leaderboard from './components/Leaderboard';
import Dashboard from './components/Dashboard';
import CompetitionHome from './components/CompetitionHome';
import CompetitionPage from './components/CompetitionPage';
// import NotFound from './components/NotFound'; // 未使用，已注释
import RouteDetailPage from './components/RouteDetailPage';
import AsynscaleHome from './components/AsynscaleHome';
import GetStarted from './components/GetStarted';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* AsynscaleAI 主页 */}
        <Route path="/" element={<AsynscaleHome />} />
        
        {/* Leaderboard 相关路由 - 添加 /leaderboard 前缀 */}
        <Route path="/leaderboard" element={<Home />} />
        <Route path="/leaderboard/login" element={<Login />} />
        <Route path="/leaderboard/register" element={<Register />} />
        <Route path="/leaderboard/get-started" element={<GetStarted />} />
        <Route path="/leaderboard/competitions" element={<CompetitionHome />} />
        <Route path="/leaderboard/competitions/:competitionId" element={<CompetitionPage />} />
        <Route path="/leaderboard/competitions/:competitionId/routes/:routeId" element={<RouteDetailPage />} />
        
        {/* 多语言路由 */}
        <Route path="/:lang" element={<Home />} />
        <Route path="/:lang/leaderboard" element={<Home />} />
        <Route path="/:lang/leaderboard/login" element={<Login />} />
        <Route path="/:lang/leaderboard/register" element={<Register />} />
        <Route path="/:lang/leaderboard/get-started" element={<GetStarted />} />
        <Route path="/:lang/leaderboard/competitions" element={<CompetitionHome />} />
        <Route path="/:lang/leaderboard/competitions/:competitionId" element={<CompetitionPage />} />
        <Route path="/:lang/leaderboard/competitions/:competitionId/routes/:routeId" element={<RouteDetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
